import ConfigurationIntegration from '~/components/ConfigurationIntegration';

export default function TagsJsIntegration({
  experimentalTagsJs = false,
  publishableToken,
  ...otherProps
}) {
  const snippet = experimentalTagsJs
    ? generateExperimentalSnippet(publishableToken)
    : generateSnippet(publishableToken);

  return <ConfigurationIntegration snippet={snippet} {...otherProps} />;
}

function generateSnippet(publishableToken) {
  return `<script>
!function(w){var clearbit=w.clearbit=w.clearbit||[];if(!clearbit.initialize)if(clearbit.invoked)w.console&&console.error&&console.error("Clearbit snippet included twice.");else{clearbit.invoked=!0;clearbit.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","page","once","off","on"];clearbit.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);clearbit.push(e);return clearbit}};for(var t=0;t<clearbit.methods.length;t++){var e=clearbit.methods[t];clearbit[e]=clearbit.factory(e)}clearbit.load=function(t){var e=document.createElement("script");e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"${snippetDomain()}/v1/"+t+"/clearbit.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};clearbit.SNIPPET_VERSION="3.1.0";
    clearbit.load("${publishableToken}");
    clearbit.page();
  }}(window);
</script>`;
}

function generateExperimentalSnippet(publishableToken) {
  const { protocol } = window.location;

  const src = `${protocol}//${snippetDomain()}/v1/${publishableToken}/tags.js`;

  return `<script src="${src}"></script>`;
}

function snippetDomain() {
  const { hostname, port } = window.location;

  if (hostname === 'x.clearbit.com') {
    return 'x.clearbitjs.com';
  } else if (hostname === 'localhost') {
    return `localhost:${port}`;
  }

  return hostname;
}
